import React from 'react';
import { observer } from 'mobx-react';
import { DeckRulebookStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class DeckRulebookCreate extends React.Component {

  onCreate = name => {
    DeckRulebookStore.create({data: {name}});
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default DeckRulebookCreate;
